/* eslint-disable */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  CircularProgress,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useContext, useEffect, useState } from 'react'
import { useApiGet } from '../../apiCalls/useApi'
import { getUserPermissions } from '../../apiCalls/permissionApi'
import { OrgAppContext } from '../../OrgAppContext'
import { useNavigate } from 'react-router-dom'

type PermissionOrg = {
  id: string
  customerId: string
  name: string
  applications: PermissionApp[]
}

type PermissionApp = {
  id: string
  orgId: string
  customerId: string
  name: string
}

type PermissionObj = {
  accessOrganizations: PermissionOrg[]
}

export default function ChooseOrgAndApp() {
  const { setCustomerId, setOrgId, setAppId, setOrgName, setAppName } =
    useContext(OrgAppContext)
  const fetchUserPermission = useApiGet(getUserPermissions)
  const navigate = useNavigate()
  const [data, setData] = useState<PermissionObj>({
    accessOrganizations: [],
  })
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    fetchUserPermission().then((res: any) => {
      if (!res || !res.accessOrganizations || res.error) {
        setIsLoading(false)
        return
      }
      const { accessOrganizations } = res
      if (accessOrganizations.length === 1 && accessOrganizations[0].applications.length === 1) {
        setCustomerId(accessOrganizations[0].customerId)
        setOrgId(accessOrganizations[0].id)
        setAppId(accessOrganizations[0].applications[0].id)
        setOrgName(accessOrganizations[0].name)
        setAppName(accessOrganizations[0].applications[0].name)
        navigate('/')
      } else {
        setData({ accessOrganizations: res.accessOrganizations })
        setIsLoading(false)
      }
    })
  }, [navigate, setAppId, setAppName, setCustomerId, setOrgId, setOrgName])

  if (isLoading) {
    return (
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f5f5f5',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f5f5f5',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: 4,
        }}
      >
        <img src='/choosePageLogo.svg' alt='Company Logo' style={{ maxWidth: '40%' }} />
      </Box>
      <Box>
        <Typography sx={{ fontWeight: '600', fontSize: '16px' }}>
          Please select Organization and application
        </Typography>
      </Box>

      <Box
        sx={{
          width: '80%',
          maxWidth: '700px',
          maxHeight: '65vh',
          overflowY: 'auto',
          marginTop: '10px',
        }}
      >
        {data.accessOrganizations.map((org: PermissionOrg) => (
          <Accordion
            key={org.id}
            disableGutters
            square={false}
            sx={{
              width: '100%',
              marginY: 2,
              borderRadius: 2,
              boxShadow: 'none',
              '&:before': { display: 'none' },
              '& .MuiAccordionSummary-root': { minHeight: 80 },
              '&:first-of-type': { borderTopLeftRadius: 8, borderTopRightRadius: 8 },
              '&:last-of-type': { borderBottomLeftRadius: 8, borderBottomRightRadius: 8 },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant='h6'>{org.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {org.applications.map((app: PermissionApp) => (
                  <ListItem
                    button
                    key={app.id}
                    onClick={() => {
                      setCustomerId(org.customerId)
                      setOrgId(org.id)
                      setAppId(app.id)
                      setOrgName(org.name)
                      setAppName(app.name)
                      navigate('/')
                    }}
                  >
                    <ListItemText primary={app.name} />
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  )
}
